/* eslint-disable */
import { Button } from "@mui/material";
import { CloseIcon } from "src/icons";
import React, { useState, useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import useYupValidationResolver from "src/hooks/useYupValidationResolver";
import * as yup from "yup";
import { useInterviewPositions } from "src/hooks/query/interviewPositions";
import RHFAutoComplete from "src/components/elements/AutoComplete/RHFAutoComplete";
import RHFInput from "src/components/elements/Input/RHFInput";
import { Loader } from "src/components";

export interface PannaInterviewFormValues {
  interviewPositionId: number;
  expiry: number;
}

interface PannaInterviewProps {
  onSubmit: (data: PannaInterviewFormValues) => void;
  onCancel: () => void;
  defaultValues?: PannaInterviewFormValues | undefined;
  loading: boolean;
}

const validationSchema = yup.object().shape({
  interviewPositionId: yup
    .number()
    .required("Please select interview position"),
  expiry: yup
    .number()
    .required("Valid number of days required")
    .integer("Expiry days must be an integer")
    .typeError("Expiry days must be an integer")
    .min(0, "Expiry days must be between 0 and 10")
    .max(10, "Expiry days must be between 0 and 10"),
});

const PannaInterview = function PannaInterview(props: PannaInterviewProps) {
  const { onSubmit, defaultValues, onCancel, loading } = props;
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const resolver = useYupValidationResolver(validationSchema);

  const {
    interviewPositionsOptions,
    interviewPositionsLoading,
    fetchInterviewPositions,
  } = useInterviewPositions();

  const methods = useForm<PannaInterviewFormValues>({
    defaultValues,
    resolver,
  });

  const { handleSubmit } = methods;

  useEffect(() => {
    if (interviewPositionsOptions.length === 0) fetchInterviewPositions();
  }, []);

  useEffect(() => {
    methods.reset(defaultValues);
  }, [defaultValues]);

  const submitHandler: SubmitHandler<PannaInterviewFormValues> = async (
    data
  ) => {
    setDisableSubmit(true);
    await onSubmit(data);
    setDisableSubmit(false);
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(submitHandler)}
        className="bg-white p-10 flex gap-8 justify-center items-center flex-col"
      >
        <div className="flex w-full flex-col gap-10 mb-5">
          <div className="text-lg text-secondary font-bold text-center ">
            Schedule Panna Interview
          </div>
          <div className="flex gap-5">
            <div className="w-[300px]">
              <RHFAutoComplete
                control={methods.control}
                name="interviewPositionId"
                placeholder="Interview position"
                options={interviewPositionsOptions}
                loading={interviewPositionsLoading}
              />
            </div>
            <div className="w-[150px]">
              <RHFInput
                control={methods.control}
                name="expiry"
                placeholder="Expiration Days"
              />
            </div>
          </div>
        </div>
        <div className="w-full flex  gap-2 ">
          <Button
            variant="contained"
            type="submit"
            size="medium"
            className="font-medium rounded-full"
            disabled={disableSubmit}
          >
            Send
          </Button>
          <Button
            variant="outlined"
            size="medium"
            className="font-medium rounded-full"
            onClick={onCancel}
            disabled={disableSubmit}
          >
            Cancel
          </Button>
        </div>
        <div className="absolute right-2 top-2" onClick={onCancel}>
          <CloseIcon className="cursor-pointer" />
        </div>
        {loading && (
          <div className="absolute top-[40%] left-[40%]">
            <Loader />
          </div>
        )}
      </form>
    </FormProvider>
  );
};

PannaInterview.defaultProps = {};

PannaInterview.propTypes = {};

export default PannaInterview;
